import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Evenings lost searching for progressions that actually work, flow logically and match your student’s specific level', 'Sessions that feel repetitive — because you keep returning to the same drills and positions you already know', 'Visible improvisation that silently erodes your confidence as an instructor', 'Little variety between weeks — and students who gradually lose motivation without knowing exactly why', 'Weekends spent planning instead of resting, recharging or living your life'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-183" data-mp="1o0d4za3mzqs0">
      <div className="max-w-3xl mx-auto" data-id="element-184" data-mp="1o1oelqjrjsr1">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-185" data-mp="1sxv82juz3bs3">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy-deep" data-id="element-186" data-mp="3nd7kfw9rskwh">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-ink leading-relaxed bg-cream-beige p-6 rounded-2xl border border-gold-light text-left space-y-4" data-id="element-187" data-mp="1yz3tspgqzocm">
            <p data-id="element-188" data-mp="27sz0i1xipmud">
              Sunday evening. 10 PM. You have a BJJ class tomorrow morning. And
              you&apos;re still here — searching online, trying to build a
              session structure that actually flows — one that matches your
              student&apos;s level, feels professional and doesn&apos;t look
              like it was thrown together in twenty minutes.
            </p>
            <p data-id="element-189" data-mp="1p28zyjvf6c4o">
              <span className="text-navy-mid font-medium" data-id="element-190" data-mp="1p30nd7ev53jv">
                Not because you don&apos;t know Brazilian Jiu-Jitsu.
              </span>{' '}
              Because nobody ever gave you a complete, structured,
              ready-to-teach library. You&apos;ve been building every single
              session from scratch.
            </p>
            <p data-id="element-191" data-mp="2vib6yu1gngsz">
              The time you should be resting — you&apos;re spending planning.
              And the worst part isn&apos;t the exhaustion. The worst part is
              walking onto the mat feeling like you could have been better
              prepared.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-192" data-mp="274xx5rtc4ryn">
          <h3 className="text-xl font-bold text-navy-deep mb-8 text-center" data-id="element-193" data-mp="1ackoha3ndr1n">
            The real cost of not having the right resource:
          </h3>
          <ul className="space-y-4" data-id="element-194" data-mp="1jeanb0zuzs9g">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-cream-card p-4 rounded-xl border border-gold-light shadow-sm" data-id="element-195" data-mp="1o6bwge1qd2v9" data-mpi={index}>
                <span className="text-navy-mid mt-1" aria-hidden="true" data-id="element-196" data-mp="j7ez13cod2i8">
                  ●
                </span>
                <span className="text-ink" data-id="element-197" data-mp="e7j3ztlyglet">{point}</span>
              </motion.li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-gold-light" data-id="element-198" data-mp="a78sk1fe92sk">
            <p className="text-2xl font-serif font-bold text-navy-deep" data-id="element-199" data-mp="574aw82r220r">
              Stop giving away your free time. Your dedication is already there.
              What you need now is{' '}
              <span className="text-gold" data-id="element-200" data-mp="3rmp8iwiw9a01">the right tool.</span>
            </p>
            <p className="text-xl mt-4 text-navy-mid" data-id="element-201" data-mp="3rkm8djo120hl">
              Solve an entire year of BJJ classes in just 5 minutes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}